import React from 'react';
import styled from 'styled-components';
import { Button, Checkbox, Form } from 'semantic-ui-react';

export const StyledButton = styled(Button)`
  &&& {
    display: flex;
    background-color: #1b1c1d;
    color: #fff;
    transition: background-color .3s ease;
  }

`;
export const ContainerLimitante = styled.div`
  margin-top: 1rem;

`;
export const StyledCheckbox = styled(Checkbox)`
  &&& {
    margin-bottom: 1rem;
  }

`;

export const StyledCheckboxLeft = styled(Checkbox)`
  &&& {
    margin-left: 1rem;
  }

`;

export const DivColumDraw = styled.div`
  border: 1px solid #0002;
  display: 'flex';
  flex-direction: 'column';
`;

export const ParagraphColumDraw = styled.p`
  font-size: 16px;
  margin-top: 5px;
`;

export const StyledLabel = styled.label`
  margin-top: 2em; 
  color: rgba(0,0,0,.87);
`;

export const LabelColumDrawBotton = styled.label`
  margin-bottom: '2em';
`;

export const StyledLabelRed = styled.label`
  color: red !important;
`;
export const StyledCheck = styled.div`
  display: inline-block;
  font-weight: normal;
  margin-left: 1rem;
  
`;


export const Field = styled(Form.Field)`
  margin: 20px 0 !important;
  width: ${props => props.big && '100%' || props.small && '20%'};
`

export const Label = styled.label`
   
  color:${props => `${props.color}`};

  font-size:12px;
  font-family:sans-serif;
  font-weight:600;
`;
